import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_URL_API_PURCHASE,
    prepareHeaders: (headers) => {
        const token = localStorage.getItem("token");
        const userId = localStorage.getItem("userId");

        if (token && token !== "") {
            headers.set("X-Auth-Token", `${token}`);
            headers.set("X-User-Id", `${userId}`);
        }

        return headers;
    },
});

const onRedirect = (callback) => {
    if (callback) callback();
    else window.location.reload();
};

const clearSession = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
};


const baseQueryWithReauth = async (args, theApi, extraOptions) => {
    let result = await baseQuery(args, theApi, extraOptions);
    if (result.error?.status === 432 || result.error?.status === 412) {
        clearSession();
        onRedirect(() => {
            if (window.location.pathname !== "/") window.location.pathname = "/";
        });
    }
    return result;
};

export const api = createApi({
    reducerPath: "purchase",
    tagTypes: ["Purchase"],
    baseQuery: baseQueryWithReauth,
    keepUnusedDataFor: 30,
    endpoints: () => ({}),
});
export default api;
